import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

export const SectionForecastDemand = ({ 
    number, 
    title, 
    children, 
    defaultOpen = true 
}) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className="rounded-lg border border-gray-200 overflow-hidden bg-white">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="w-full flex items-center gap-2 px-5 py-3 border-b border-gray-200 hover:bg-gray-50 transition-colors"
            >
                <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-gray-900 text-white text-[10px] font-bold shrink-0">
                    {number}
                </span>
                <span className="text-[13px] font-semibold text-gray-900 flex-1 text-left">{title}</span>
                {open ? (
                    <ChevronDown size={14} className="text-gray-500" />
                ) : (
                    <ChevronRight size={14} className="text-gray-500" />
                )}
            </button>
            {open && <div className="p-3 xl:p-5">{children}</div>}
        </div>
    );
}